import { defineAsyncComponent } from '../compat/vueCompat';
import type { PremiereProject } from '../premiere/interfaces';
import { requestDialog } from './requestDialog';
import type { SavePremiereProjectDialogRequest } from './savePremiereProjectDialogRequest';

const SavePremiereProjectDialog = defineAsyncComponent(() => import('@mimir/web/components/Common/Dialogs/dialogs/SavePremiereProjectDialog.vue'));

export function showSavePremiereProjectDialog(
  project: PremiereProject,
  targetFolderId: string | undefined,
) {
  const req: SavePremiereProjectDialogRequest = {
    project,
    targetFolderId,
  };
  requestDialog(req, SavePremiereProjectDialog);
}
